import { UxGameController } from './ux-game-controller';
import { BlackjackApp } from 'src/games/phaserblackjack/game/blackjack-app';
import { BlackjackPreloadScene } from 'src/games/phaserblackjack/game/scenes/blackjack-preload-scene';
import { BlackjackUxGameListener } from '../listeners/blackjack-ux-game-listener';
import { BlackjackMainScene } from 'src/games/phaserblackjack/game/scenes/blackjack-main-scene';
import { Observable } from 'rxjs';
import { ActionBus, Blackjack } from 'game-logic';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { GameId } from 'src/app/model/game/game-id';
import { UxGameServiceAction } from 'src/app/core/services/ux-game/ux-game-service-action';

export class BlackjackUxGameController extends UxGameController {
  public override get gameId(): GameId {
    return GameId.Blackjack;
  }
  public get roundState$(): Observable<Blackjack.RoundState> {
    return this.blackjackListener.roundState$;
  }
  public get availablePlayerControls$(): Observable<Blackjack.PlayerControls[]> {
    return this.blackjackListener.availablePlayerControls$;
  }
  public get currentBet$(): Observable<number> {
    return this.blackjackListener.currentBet$;
  }

  private blackjackListener: BlackjackUxGameListener;
  private blackjackMainScene: BlackjackMainScene;

  constructor(
    gameListener: BlackjackUxGameListener,
    gameServiceActionBus: ActionBus<UxGameServiceAction>,
    services: UxGameServices,
  ) {
    // TODO: How can we dynamically create use a localDealer?
    const blackjackApp = new BlackjackApp(gameListener, services.themeService, false);
    const preloadScene = new BlackjackPreloadScene(
      blackjackApp,
      services.themeService.blackjackAssetPath(),
    );
    preloadScene.preloadTranslations(services.translocoService);
    const mainScene = new BlackjackMainScene(blackjackApp);

    super(gameListener, preloadScene, mainScene, gameServiceActionBus, services);

    this.blackjackListener = gameListener;
    this.blackjackMainScene = mainScene;
  }

  uiButtonTapped(uiButton: Blackjack.UiButtonType): void {
    this.blackjackMainScene.uiButtonTapped(uiButton);
  }

  protected override resetGame(): void {
    super.resetGame();
    this.blackjackMainScene.resetGameScene();
  }

  public override setGameVisible(isVisible: boolean): void {
    this.blackjackMainScene.setGameVisible(isVisible);
  }
}
